export const blockIconsPhotoandimageImagesmodeNew = (
	<span className='material-symbols-outlined'>imagesmode</span>
);
